import React, { useEffect, useState } from 'react';
import { Spin, Tooltip } from 'antd';

import {
  DownOutlined,
  LoadingOutlined,
  WarningOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

import Styles from './ChatWidget.module.scss';

const widgetSelector = '.gcc1e4ac212e5.gcc4287ff10a2.gcca867f0a812.gccbd2f1335b9.gcc73b5e85ef5.gcce6a1d7b821.gccd1b21b083b';

/**
 * This component wait until the DOM content is loaded, then search for the chat widget,
 * which come from special CDN located in accounts.html,
 * we do this in this way to have the complete power to customize
 * the widget with our icons and colors.
 */
const ChatWidget = () => {
  const [widgetElement, setWidgetElement] = useState(undefined);
  const [widgetLoaded, setWidgetLoaded] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [widgetError, setWidgetError] = useState(false);

  const widgetSearcher = () => {
    const interval = setInterval(() => {
      const domWidgetSelected = document.querySelector(widgetSelector);
      if (domWidgetSelected) {
        setWidgetElement(domWidgetSelected);
        setWidgetLoaded(true);
        clearInterval(interval);
      }
    }, 300);
  };

  useEffect(() => {
    document.addEventListener('DOMContentLoaded', widgetSearcher);

    return () => {
      document.removeEventListener('DOMContentLoaded', widgetSearcher);
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!document.querySelector(widgetSelector)) {
        setWidgetError(true);
      }
    }, 90000); // 1.5 minutes

    return () => clearTimeout(timeout);
  }, []);

  const handleButtonClick = () => {
    if (widgetElement) {
      widgetElement.click();
      setIsClicked(!isClicked);
    }
  };

  return (
    <Tooltip title="Edunext Chat Bot" placement="left">
      <button
        onClick={handleButtonClick}
        type="button"
        className={`${Styles.button} ${widgetError && Styles.error}`}
      >
        {widgetLoaded ? (
          <>
            {isClicked ? (
              <DownOutlined className={Styles.widgetIcons} />
            ) : (
              <QuestionCircleOutlined className={Styles.widgetIcons} />
            )}
          </>
        ) : (
          <>
            {widgetError ? (
              <WarningOutlined className={Styles.widgetIcons} />
            ) : (
              <Spin
                indicator={
                  <LoadingOutlined className={Styles.loaderIcon} spin />
                }
              />
            )}
          </>
        )}
      </button>
    </Tooltip>
  );
};

export default ChatWidget;
